<template>
  <div id="app">
    <nav style="background-color: #f0932b" class="navbar navbar-expand-md navbar-light">
      <div class="d-flex w-50">
        <!-- <router-link tag="img" src="../assets/logo1.png" :to="{ name: 'Homepage' }"></router-link> -->
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbar">
          <span class="navbar-toggler-icon"></span>
        </button>
      </div>
      <div class="collapse navbar-collapse justify-content-center" id="navbar">
        <div class="navbar-nav">

          <!--
          <router-link data-toggle="collapse" data-target="#navbar" class="nav-item nav-link text-white" :to="{ name: 'Homepage' }">Home</router-link>
          <router-link data-toggle="collapse" data-target="#navbar" class="nav-item nav-link text-white" :to="{ name: 'Mission' }" >L'Esperienza</router-link>
          <router-link data-toggle="collapse" data-target="#navbar" class="nav-item nav-link text-white" :to="{ name: 'Fiorino' }" >La&nbsp;Blockchain</router-link>
          <router-link data-toggle="collapse" data-target="#navbar" class="nav-item nav-link text-white" :to="{ name: 'Mission' }" >Il&nbsp;Fiorino</router-link>
          <router-link data-toggle="collapse" data-target="#navbar" class="nav-item nav-link text-white" :to="{ name: 'Projects' }" >Made&nbsp;In&nbsp;KibiGo</router-link>
          <a data-toggle="collapse" data-target="#navbar" class="nav-item nav-link text-white" href="https://medium.com/kinoa" >Blog</a>
          <router-link data-toggle="collapse" data-target="#navbar" class="nav-item nav-link text-white" :to="{ name: 'ContactUs' }" >Partecipa</router-link>
          -->

          <router-link class="nav-item nav-link text-white" :to="{ name: 'Homepage' }">{{$t("bar_home")}}</router-link>
          <router-link class="nav-item nav-link text-white" :to="{ name: 'Mission' }" >{{$t("bar_exp")}}</router-link>
          <router-link class="nav-item nav-link text-white" :to="{ name: 'Blockchain' }" >{{$t("bar_BC")}}</router-link>
          <router-link class="nav-item nav-link text-white" :to="{ name: 'Fiorino' }" >{{$t("bar_fiorino")}}</router-link>
          <router-link class="nav-item nav-link text-white" :to="{ name: 'Projects' }" >{{$t("bar_mik")}}&nbsp;{{$t("bar_mik2")}}&nbsp;{{$t("bar_mik3")}}</router-link>
          <a class="nav-item nav-link text-white" href="https://medium.com/kinoa/kibigo/" >{{$t("bar_blog")}}</a>
          <a class="nav-item nav-link text-white" href="https://www.kinoa.tech/dicono-di-noi-kibigo/" >{{$t("bar_about")}}&nbsp;{{$t("bar_about1")}}&nbsp;{{$t("bar_about2")}}</a>
          <router-link class="nav-item nav-link text-white" :to="{ name: 'ContactUs' }" >{{$t("bar_cta")}}</router-link>
          
          
        
        </div>
      </div>
      <span class="w-50 text-right">
        <LoginButton/>
      </span>
    </nav>

    <router-view/>

    <!-- Scroll to top Button -->
    <button @click="scrollToTop()" class="btn btn-secondary loginbutton" id="scrollToTopButton" title="Go to top">
      <i @click="scrollToTop()" class="fas fa-caret-up"></i>
    </button>

    <footer class="mt-5 footer text-center">
      <div class="container">
        <ul class="list-inline mb-5">

          <li class="list-inline-item">
            <a class="social-link rounded-circle text-white " href="http://instagram.com/kibigo.kinoa/">
              <i class="icon-social-instagram"></i>
            </a>
          </li>
          <li class="list-inline-item">
            <a class="social-link rounded-circle text-white mr-3" href="https://www.youtube.com/channel/UCigmk-vz0pQMDj3Pgz14WjQ?view_as=subscriber">
              <i class="icon-social-youtube"></i>
            </a>
          </li>
        </ul>
    <div class="dropdown ">
  <button v-if= "en" class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenu2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
    {{$t("language_eng")}}
  </button>
   <button v-else class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenu2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
    {{$t("language_ita")}}
  </button>
  <div class="dropdown-menu" aria-labelledby="dropdownMenu2">
     <button @click="setIta" class="dropdown-item" type="button">{{$t("language_ita")}}</button>
    
   
    <button @click="setEng" class="dropdown-item" type="button">{{$t("language_eng")}}</button>
  </div>
</div>
        <p class="text-white text-center small mb-0">Copyright &copy; <a href="https://www.kinoa.tech"> Kinoa</a> 2018</p>
     
      </div>
    </footer>
  </div>
</template>

<script>
import LoginButton from "@/components/LoginButton";

export default {
  name: "App",
  data() {
    return {
      en: true
    };
  },
  components: {
    LoginButton
  },
  methods: {
    setIta: function() {
      localStorage.setItem("choose_lang", "it"), window.location.reload(true);
      console.log(localStorage.getItem("choose_lang"));
    },
    setEng: function() {
      localStorage.setItem("choose_lang", "en"), window.location.reload(true);
    },

    scrollFunction: function() {
      let button = document.getElementById("scrollToTopButton");
      if (
        document.body.scrollTop > 500 ||
        document.documentElement.scrollTop > 500
      )
        button.style.display = "block";
      else button.style.display = "none";
    },
    scrollToTop: function() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    }
  },
  created() {
     
    if(localStorage.getItem('choose_lang') == "en") {
      this.en = true
    }
    else {
      this.en = false
    };
    window.addEventListener("scroll", this.scrollFunction);
  }
};
</script>

<style>
a:link {
  text-decoration: none;
}

a:visited {
  text-decoration: none;
}

a:hover {
  text-decoration: none;
}

a:active {
  text-decoration: none;
}

nav.navbar.navbar-light {
  background-color: rgba(0, 0, 0, 0.08);
}

.navbar {
  font-size: 18px;
}

.navbar #navbar {
  margin-right: 20px;
}

.navbar .log-in-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}

.navbar .log-in-icon button {
  background-color: rgba(0, 0, 0, 0);
  border: none;
}

.footer {
  color: rgb(255, 255, 255);
  background-color: #d6780d;
}

.copyright {
  color: white;
}

#scrollToTopButton {
  display: none;
  position: fixed;
  bottom: 20px;
  right: 30px;
  z-index: 99;
  outline: none;
  cursor: pointer;
  background-color: #d6780d;
  border: none;
  color: rgb(255, 255, 255);
  font-size: 30px;
}

@media (min-width: 768px) {
  #scrollToTopButton {
    font-size: inherit;
  }
}
/*
#scrollToTopButton:hover {
  background-color: #555;
}*/
</style>



// WEBPACK FOOTER //
// src/App.vue